import { FormField } from '@/_components';
import { Address } from '@/_containers';
import { showFormField } from '@/_shared';

import type { AddressSectionProps } from './types';

import { usePickTicketsFormContext } from '../../form-context';

export function AddressSection({ isEdit, onRequestEdit }: AddressSectionProps) {
  const form = usePickTicketsFormContext();

  const [addresses] = form.watch(['delivery_address']);

  return (
    showFormField(isEdit, addresses?.[0]) && (
      <FormField
        control={form.control}
        name="delivery_address"
        render={({ field }) => (
          <Address
            type="contact"
            text="Delivery Address"
            value={addresses?.[0]}
            isEdit={isEdit}
            onChange={field.onChange}
            onRequestEdit={onRequestEdit}
          />
        )}
      />
    )
  );
}
